export default __webpack_public_path__ + "static/media/10.d4d88c56.jpeg";